/*! ******************************
@bilibili-live/unreal-animation-magician.
© 2014 - 2021 Bilibili Live Department.
Build: 2021-11-04, 11:48:01
Version: 1.0.0-16
Env: production
===
「あなたに逢えなくなって、錆びた時計と泣いたけど…」
# Carry Your World #
****************************** */

/** @format */
/**
 * remove 方法兼容判断
 *
 * @export
 * @param {HTMLElement} target
 */
function removeElement(target) {
    if (target.remove) {
        target.remove();
        return;
    }
    target.parentNode && target.parentNode.removeChild(target);
}
/**
 * 创建离屏 canvas
 *
 * @export
 * @returns
 */
function getCanvas(width, height, isAutoDpr) {
    if (isAutoDpr === void 0) { isAutoDpr = true; }
    var dpr = (isAutoDpr && Math.floor(window.devicePixelRatio)) || 1;
    var canvas = document.createElement('canvas');
    canvas.style.cssText = "width:" + width + "px;height:" + height + "px;";
    canvas.style.display = 'none';
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    document.body.appendChild(canvas);
    return {
        canvas: canvas,
        ctx: ctx,
    };
}
/**
 * 加载图片
 *
 * @export
 * @param {*} url
 * @param {*} [defaultImg]
 * @returns
 */
function loadImg(url, defaultImg) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
            resolve(this);
        };
        img.onerror = function (e) {
            if (defaultImg) {
                resolve(defaultImg);
                return;
            }
            console.error(e);
            reject(Error('load error: ' + url));
        };
        img.src = url;
    });
}
function createShader(gl, type, sourceCode) {
    // Compiles either a shader of type gl.VERTEX_SHADER or gl.FRAGMENT_SHADER
    // 创建着色器对象
    var shader = gl.createShader(type);
    // 将源码分配给着色器对象
    gl.shaderSource(shader, sourceCode);
    // 编译着色器程序
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        var info = gl.getShaderInfoLog(shader);
        throw new Error('Could not compile WebGL program. \n\n' + info);
    }
    return shader;
}
function createProgram(gl, vertexShader, fragmentShader) {
    // 创建着色器程序
    var program = gl.createProgram();
    // 将顶点着色器挂载在着色器程序上
    gl.attachShader(program, vertexShader);
    // 将片元着色器挂载在着色器程序上
    gl.attachShader(program, fragmentShader);
    // 链接着色器程序
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        var info = gl.getProgramInfoLog(program);
        throw new Error('Could not compile WebGL program. \n\n' + info);
    }
    // 使用刚创建好的着色器程序.
    gl.useProgram(program);
    return program;
}
function createTexture(gl, index, imgData) {
    var textureIndex = gl.TEXTURE0 + index;
    gl.activeTexture(textureIndex);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); // NEAREST
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    if (imgData) {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, imgData);
    }
    return texture;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @format */
/**
 * 解析融合数据
 *
 * @class FrameParser
 */
var FrameParser = /** @class */ (function () {
    function FrameParser(options) {
        var _a;
        this.srcData = [];
        this.textureMap = Object.create(null);
        this.config = options.config; // 资源输出的 json 配置
        this.headData = options;
        this.frame = (_a = this.config['frame']) !== null && _a !== void 0 ? _a : [];
    }
    FrameParser.prototype.makeTextImg = function (item) {
        var _a, _b;
        var w = item.w, h = item.h, color = item.color, style = item.style, textStr = item.textStr, fontStyle = item.fontStyle;
        var _c = getCanvas(w, h), canvas = _c.canvas, ctx = _c.ctx;
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        var getFontStyle = function () {
            var fontSize = Math.min(w / textStr.length, h - 8);
            var font = [fontSize + "px", 'Arial, Helvetica, sans-serif'];
            if (style === 'b') {
                font.unshift('bold');
            }
            return font.join(' ');
        };
        var font = getFontStyle();
        var fillStyle = color;
        ctx.font = font;
        ctx.fillStyle = fillStyle;
        if (typeof fontStyle === 'string') {
            ctx.font = fontStyle;
        }
        else if (typeof fontStyle === 'object' && fontStyle !== null) {
            ctx.font = (_a = fontStyle.font) !== null && _a !== void 0 ? _a : font;
            ctx.fillStyle = (_b = fontStyle.color) !== null && _b !== void 0 ? _b : fillStyle;
        }
        else if (typeof fontStyle === 'function') {
            fontStyle.call(null, ctx, item);
        }
        ctx.fillText(textStr, w / 2, h / 2);
        var img = ctx.getImageData(0, 0, canvas.width, canvas.height);
        removeElement(canvas);
        return img;
    };
    FrameParser.prototype.parseSrc = function (dataJson) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var dataSrc, _b, canvas, ctx, empty;
            var _this = this;
            return __generator(this, function (_c) {
                dataSrc = (_a = dataJson === null || dataJson === void 0 ? void 0 : dataJson.src) !== null && _a !== void 0 ? _a : [];
                _b = getCanvas(10, 10), canvas = _b.canvas, ctx = _b.ctx;
                empty = ctx.getImageData(0, 0, canvas.width, canvas.height);
                removeElement(canvas);
                return [2 /*return*/, Promise.all(dataSrc.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                        var fontStyle, textStr, img, imgUrl, img;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(this.headData[item.srcTag.slice(1, item.srcTag.length - 1)] || this.headData[item.srcTag])) {
                                        console.warn("[uam-FrameParser]: \u7F3A\u5C11\u878D\u5408\u4FE1\u606F > " + item.srcTag);
                                        return [2 /*return*/, __assign(__assign({}, item), { img: +item.isNecessary ? null : empty })];
                                    }
                                    if (item.srcType === 'txt') {
                                        fontStyle = this.headData.fontStyle && !item.fontStyle ? this.headData.fontStyle : item.fontStyle;
                                        textStr = this.headData[item.srcTag] || item.srcTag.replace(/\[(.*)\]/, function ($0, $1) { return _this.headData[$1]; });
                                        img = this.makeTextImg(__assign(__assign({}, item), { fontStyle: fontStyle, textStr: textStr }));
                                        return [2 /*return*/, __assign(__assign({}, item), { img: img })];
                                    }
                                    if (!(item.srcType === 'img')) return [3 /*break*/, 5];
                                    imgUrl = this.headData[item.srcTag] || item.srcTag.replace(/\[(.*)\]/, function ($0, $1) { return _this.headData[$1]; });
                                    img = imgUrl instanceof ImageData && imgUrl || null;
                                    if (!!img) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, loadImg(imgUrl)];
                                case 2:
                                    img = (_a.sent());
                                    return [3 /*break*/, 4];
                                case 3:
                                    _a.sent();
                                    img = +item.isNecessary ? null : empty;
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/, __assign(__assign({}, item), { img: img })];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); }))];
            });
        });
    };
    FrameParser.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.parseSrc(this.config)];
                    case 1:
                        _a.srcData = _b.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    FrameParser.prototype.getFrame = function (frame) {
        return this.frame.find(function (item) { return item.i === frame; });
    };
    return FrameParser;
}());

/** @format */
function computeCoord(x, y, w, h, vw, vh) {
    // leftX rightX bottomY topY
    return [x / vw, (x + w) / vw, (vh - y - h) / vh, (vh - y) / vh];
}
var PER_SIZE = 9;
var WebglRender = /** @class */ (function () {
    function WebglRender(options) {
        this._log = '';
        this.instance = {};
        this.textures = [];
        this.buffers = [];
        if (!options.container || !options.src) {
            console.warn('[Alpha video]: options container and src cannot be empty!');
        }
        this.options = Object.assign({
            // 容器
            container: null,
            // 视频url
            src: '',
            config: '',
            // 视频宽度
            width: 375,
            // 视频高度
            height: 375,
            // 是否静音播放
            mute: false,
            // 循环播放
            loop: false,
            offset: 0,
            precache: false,
        }, options);
        this.container = this.options.container;
        this.logger = "[constructor]:";
        this.requestAnime = this.requestAnimationFunc();
        this.initVideo();
        this.setCanvas();
        this.init();
    }
    WebglRender.prototype.initVideo = function () {
        var _this = this;
        var options = this.options;
        // 创建video
        var video = (this.video = document.createElement('video'));
        video.crossOrigin = 'anonymous';
        video.autoplay = false;
        video.preload = 'auto';
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        if (options.mute) {
            video.muted = true;
            video.volume = 0;
        }
        video.style.display = 'none';
        video.loop = !!options.loop;
        if (options.precache) ;
        else {
            video.src = options.src;
            // 这里要插在body上，避免container移动带来无法播放的问题
            document.body.appendChild(this.video);
            video.load();
        }
        this.logger = '[video]: create video';
        // 绑定事件
        this.events = {};
        ['playing', 'pause', 'ended', 'error'].forEach(function (item) {
            _this.on(item, _this['on' + item].bind(_this));
        });
    };
    WebglRender.prototype.setCanvas = function () {
        var _a = this.options, width = _a.width, height = _a.height;
        var canvas = (this.instance.canvas = document.createElement('canvas'));
        canvas.width = width;
        canvas.height = height;
        this.container.appendChild(canvas);
    };
    WebglRender.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, canvas;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, new FrameParser(this.options).init()];
                    case 1:
                        _a.uamFrameParser = _b.sent();
                        this.resources = this.uamFrameParser.srcData;
                        if (this.resources.filter(function (item) { return !item.img; }).length > 0) {
                            canvas = this.instance.canvas;
                            canvas && removeElement(canvas);
                            if (this.video) {
                                removeElement(this.video);
                                this.video = null;
                            }
                            this.options.onDestroy && this.options.onDestroy({ isEnded: true });
                            return [2 /*return*/];
                        }
                        this.initWebGL();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebglRender.prototype.initWebGL = function () {
        var canvas = this.instance.canvas;
        var _a = this.instance, gl = _a.gl, vertexShader = _a.vertexShader, fragmentShader = _a.fragmentShader, program = _a.program;
        if (!canvas) {
            return;
        }
        if (!gl) {
            gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
            this.instance.gl = gl;
            gl.enable(gl.BLEND);
            gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
        }
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.viewport(0, 0, canvas.width, canvas.height);
        if (!vertexShader) {
            vertexShader = this.instance.vertexShader = this.initVertexShader();
        }
        if (!fragmentShader) {
            fragmentShader = this.instance.fragmentShader = this.initFragmentShader();
        }
        if (!program) {
            program = this.instance.program = createProgram(gl, vertexShader, fragmentShader);
        }
        this.program = program;
        this.setVertexShaderAttribute();
        this.setTexture();
        this.play();
        return gl;
    };
    WebglRender.prototype.initVertexShader = function () {
        var gl = this.instance.gl;
        return createShader(gl, gl.VERTEX_SHADER, "\n      attribute vec2 a_position; // \u63A5\u53D7\u9876\u70B9\u5750\u6807\n      attribute vec2 a_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807\n      attribute vec2 a_alpha_texCoord; // \u63A5\u53D7 alpha \u7EB9\u7406\u5750\u6807\n      varying   vec2 v_texCoord; // \u4F20\u9012\u7EB9\u7406\u5750\u6807\u7ED9\u7247\u5143\u7740\u8272\u5668\n      varying   vec2 v_alpha_texCoord; // \u4F20\u9012\u7EB9\u7406\u5750\u6807\u7ED9\u7247\u5143\u7740\u8272\u5668\n      void main(void){\n        gl_Position = vec4(a_position, 0.0, 1.0); // \u8BBE\u7F6E\u5750\u6807\n        v_texCoord = a_texCoord; // \u8BBE\u7F6E\u7EB9\u7406\u5750\u6807\n        v_alpha_texCoord = a_alpha_texCoord; // \u8BBE\u7F6E\u7EB9\u7406\u5750\u6807\n      }\n      ");
    };
    WebglRender.prototype.initFragmentShader = function () {
        var gl = this.instance.gl;
        var bgColor = 'vec4(texture2D(u_image_video, v_texCoord).rgb, texture2D(u_image_video, v_alpha_texCoord).r)';
        var texTureSize = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 1;
        var sourceUniform = (function () {
            if (texTureSize > 0) {
                var imgColor = [];
                var samplers = [];
                for (var i = 1; i <= texTureSize; i++) {
                    samplers.push("\n          uniform sampler2D u_image" + i + ";");
                    imgColor.push("\n            if (ndx == " + i + ") {\n              color = texture2D(u_image" + i + ", uv);\n            }\n          ");
                }
                return "\n          " + samplers.join('') + "\n          uniform float image_pos[" + texTureSize * PER_SIZE + "];\n          vec4 getSamplerFormArray(int ndx, vec2 uv) {\n            vec4 color;\n            " + imgColor.join(' else ') + "\n            return color;\n          }\n        ";
            }
        })();
        var sourceTexture = "\n      vec4 srcColor, maskColor;\n      vec2 srcTexCoord, maskTexCoord;\n      int srcIndex;\n      float x1,x2,y1,y2,mx1,mx2,my1,my2; // \u663E\u793A\u533A\u57DF\n      for (int i = 0; i < " + texTureSize * PER_SIZE + "; i += " + PER_SIZE + ") {\n        if (int(image_pos[i]) > 0) {\n          srcIndex = int(image_pos[i]);\n          x1 = image_pos[i+1];\n          x2 = image_pos[i+2];\n          y1 = image_pos[i+3];\n          y2 = image_pos[i+4];\n          mx1 = image_pos[i+5];\n          mx2 = image_pos[i+6];\n          my1 = image_pos[i+7];\n          my2 = image_pos[i+8];\n\n          if (v_texCoord.s > x1 && v_texCoord.s < x2 && v_texCoord.t > y1 && v_texCoord.t < y2) {\n            srcTexCoord = vec2((v_texCoord.s - x1) / (x2 - x1), (v_texCoord.t - y1) / (y2 - y1));\n            maskTexCoord = vec2(mx1 + srcTexCoord.s * (mx2 - mx1), my1 + srcTexCoord.t * (my2 - my1));\n            srcColor = getSamplerFormArray(srcIndex, srcTexCoord);\n            maskColor = texture2D(u_image_video, maskTexCoord);\n            srcColor.a = srcColor.a * (maskColor.b);\n\n            bgColor = vec4(srcColor.rgb * srcColor.a, srcColor.a) + (1.0 - srcColor.a) * bgColor;\n          }\n        }\n      }\n    ";
        var fragmentShader = "\n      precision lowp float;\n      varying vec2 v_texCoord;\n      varying vec2 v_alpha_texCoord;\n      uniform sampler2D u_image_video;\n      " + sourceUniform + "\n\n      void main(void) {\n        vec4 bgColor = " + bgColor + ";\n        " + sourceTexture + "\n        gl_FragColor = bgColor;\n      }\n    ";
        return createShader(gl, gl.FRAGMENT_SHADER, fragmentShader);
    };
    WebglRender.prototype.setVertexShaderAttribute = function () {
        var gl = this.instance.gl;
        var info = this.options.config['info'];
        if (!info) {
            return;
        }
        var ver = [];
        var vW = info.videoW, vH = info.videoH;
        var _a = __read(info.rgbFrame, 4), rgbX = _a[0], rgbY = _a[1], rgbW = _a[2], rgbH = _a[3];
        var _b = __read(info.aFrame, 4), aX = _b[0], aY = _b[1], aW = _b[2], aH = _b[3];
        var rgbCoord = computeCoord(rgbX, rgbY, rgbW, rgbH, vW, vH);
        var aCoord = computeCoord(aX, aY, aW, aH, vW, vH);
        ver.push.apply(ver, __spread([-1, 1, rgbCoord[0], rgbCoord[3], aCoord[0], aCoord[3]]));
        ver.push.apply(ver, __spread([1, 1, rgbCoord[1], rgbCoord[3], aCoord[1], aCoord[3]]));
        ver.push.apply(ver, __spread([-1, -1, rgbCoord[0], rgbCoord[2], aCoord[0], aCoord[2]]));
        ver.push.apply(ver, __spread([1, -1, rgbCoord[1], rgbCoord[2], aCoord[1], aCoord[2]]));
        var aPosition = gl.getAttribLocation(this.program, 'a_position');
        gl.enableVertexAttribArray(aPosition);
        var aTexCoord = gl.getAttribLocation(this.program, 'a_texCoord');
        gl.enableVertexAttribArray(aTexCoord);
        var aAlphaTexCoord = gl.getAttribLocation(this.program, 'a_alpha_texCoord');
        gl.enableVertexAttribArray(aAlphaTexCoord);
        var vertexBuffer = gl.createBuffer();
        this.buffers.push(vertexBuffer);
        var view = new Float32Array(ver);
        gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
        var size = view.BYTES_PER_ELEMENT; // 4
        var stride = size * 6;
        gl.vertexAttribPointer(aPosition, 2, gl.FLOAT, false, stride, 0);
        gl.vertexAttribPointer(aTexCoord, 2, gl.FLOAT, false, stride, size * 2);
        gl.vertexAttribPointer(aAlphaTexCoord, 2, gl.FLOAT, false, stride, size * 4);
        gl.bufferData(gl.ARRAY_BUFFER, view, gl.STATIC_DRAW);
    };
    WebglRender.prototype.setTexture = function () {
        var _this = this;
        var gl = this.instance.gl;
        var i = 1;
        this.resources.forEach(function (item) {
            _this.textures.push(createTexture(gl, i, item.img));
            var sampler = gl.getUniformLocation(_this.program, "u_image" + i);
            gl.uniform1i(sampler, i);
            _this.uamFrameParser.textureMap[item.srcId] = i++;
        });
        gl.activeTexture(gl.TEXTURE0);
        var dumpTexture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, dumpTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        this.videoTexture = createTexture(gl, i);
        var sampler = gl.getUniformLocation(this.program, 'u_image_video');
        gl.uniform1i(sampler, i);
    };
    WebglRender.prototype.drawFrame = function () {
        var _this = this;
        var gl = this.instance.gl;
        var info = (this.options.config || Object.create(null)).info;
        var fps = info.fps || 15;
        var timePoint = this.video.currentTime;
        gl.clear(gl.COLOR_BUFFER_BIT);
        if (this.uamFrameParser) {
            var frame = Math.round(timePoint * fps) + this.options.offset;
            var frameData = this.uamFrameParser.getFrame(frame);
            // console.dir(frameData)
            var posArr_1 = [];
            if (frameData && frameData.obj) {
                frameData.obj.forEach(function (frame) {
                    posArr_1[posArr_1.length] = +_this.uamFrameParser.textureMap[frame.srcId];
                    var vW = info.videoW, vH = info.videoH;
                    var _a = __read(info.rgbFrame, 2), rgbX = _a[0], rgbY = _a[1];
                    var _b = __read(frame.frame, 4), x = _b[0], y = _b[1], w = _b[2], h = _b[3];
                    var _c = __read(frame.mFrame, 4), mX = _c[0], mY = _c[1], mW = _c[2], mH = _c[3];
                    var coord = computeCoord(x + rgbX, y + rgbY, w, h, vW, vH);
                    var mCoord = computeCoord(mX, mY, mW, mH, vW, vH);
                    posArr_1 = posArr_1.concat(coord).concat(mCoord);
                });
            }
            this._texTureSize = this._texTureSize || gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 1;
            var size = this._texTureSize * PER_SIZE;
            posArr_1 = posArr_1.concat(new Array(size - posArr_1.length).fill(0));
            this._imagePos = this._imagePos || gl.getUniformLocation(this.program, 'image_pos');
            gl.uniform1fv(this._imagePos, new Float32Array(posArr_1));
        }
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.video);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        this.animId = this.requestAnime(this.drawFrame.bind(this));
    };
    WebglRender.prototype.requestAnimationFunc = function () {
        var info = (this.options.config || Object.create(null)).info;
        var fps = info.fps || 15;
        var index = -1;
        return function (cb) {
            var _this = this;
            index++;
            return requestAnimationFrame(function () {
                if (!(index % (60 / fps))) {
                    return cb();
                }
                _this.animId = _this.requestAnime(cb);
            });
        };
    };
    WebglRender.prototype.cancelRequestAnimation = function () {
        this.animId && cancelAnimationFrame(this.animId);
    };
    WebglRender.prototype.play = function () {
        var _this = this;
        var prom = this.video && this.video.play();
        if (prom && prom.then) {
            prom.catch(function () {
                if (!_this.video) {
                    return;
                }
                _this.video.muted = true;
                _this.video.volume = 0;
                _this.video.play().catch(function (e) {
                    var _a;
                    (_a = _this.events.error) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                        typeof item === 'function' && item(e);
                    });
                });
            });
        }
    };
    WebglRender.prototype.onplaying = function () {
        this.logger = '[events]: playing';
        if (!this.firstPlaying) {
            this.firstPlaying = true;
            this.drawFrame();
        }
    };
    WebglRender.prototype.onpause = function () {
        this.logger = '[events]: pause';
    };
    WebglRender.prototype.onended = function () {
        this.logger = '[events]: ended';
        this.destroy({ isEnded: true });
    };
    WebglRender.prototype.onerror = function (err) {
        this.logger = '[events]: error';
        console.error('[video]: play error: ', err);
        this.clear();
        this.options.onLoadError && this.options.onLoadError(err);
    };
    WebglRender.prototype.clear = function () {
        this.cancelRequestAnimation();
        var _a = this.instance, canvas = _a.canvas, gl = _a.gl;
        this.videoTexture && gl.deleteTexture(this.videoTexture);
        this.textures.forEach(function (texture) {
            gl.deleteTexture(texture);
        });
        gl.clear(gl.COLOR_BUFFER_BIT);
        canvas && removeElement(canvas);
        if (this.video) {
            removeElement(this.video);
            this.video = null;
        }
    };
    Object.defineProperty(WebglRender.prototype, "logger", {
        get: function () {
            return this._log;
        },
        set: function (value) {
            this._log = this._log + '\n' + value;
        },
        enumerable: false,
        configurable: true
    });
    WebglRender.prototype.on = function (event, callback) {
        var cbs = this.events[event] || [];
        cbs.push(callback);
        this.events[event] = cbs;
        this.video.addEventListener(event, callback);
        return this;
    };
    WebglRender.prototype.destroy = function (res) {
        this.logger = '[destroyed]';
        this.clear();
        this.options.onDestroy && this.options.onDestroy(res);
    };
    return WebglRender;
}());

/** @format */
var isCanWebGL;
function canWebGL() {
    if (typeof isCanWebGL !== 'undefined') {
        return isCanWebGL;
    }
    try {
        // @ts-ignore
        if (!window.WebGLRenderingContext) {
            return false;
        }
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        isCanWebGL = !!(context && context instanceof WebGLRenderingContext);
        context = null;
    }
    catch (err) {
        isCanWebGL = false;
    }
    return isCanWebGL;
}
/**
 * UAM
 *
 * @export
 * @param {IUamConfig} options
 * @returns {WebglRender}
 */
function UAM(options) {
    if (canWebGL()) {
        return new WebglRender(options);
    }
    else {
        throw new Error('your browser not support webgl');
    }
}
function parseResourcesJson(url) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'json';
        xhr.onload = function () {
            if (xhr.status === 200 || (xhr.status === 304 && xhr.response)) {
                resolve(xhr.response);
            }
            else {
                reject(Error("http response invalid " + xhr.status));
            }
        };
        xhr.onerror = function () {
            reject(Error("http response invalid"));
        };
        xhr.send();
    });
}

export { UAM, getCanvas, loadImg, parseResourcesJson, removeElement };
